module.exports = __webpack_public_path__ + "static/media/h7_comserv_bw.d728be8c.webp";